import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

class VectorStoreService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  updateStoreData() {
    return this.post<boolean, {}>('vector-store', {})
  }
}

export const vectorStoreService = new VectorStoreService()

export default VectorStoreService
